import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import type { TileLayer } from 'leaflet';

// Base-tile opacity curve. The choropleth overlay itself fades out as the user
// zooms in (fillOpacityScale: 9→0.85, 14→0.10), so the base map can stay at
// full opacity at every zoom. User explicitly asked for full brightness.
function opacityForZoom(_zoom: number): number {
  return 1;
}

export function useAdaptiveOpacity(layerRef: React.RefObject<TileLayer | null>) {
  const map = useMap();
  const lastZoom = useRef<number | null>(null);

  useEffect(() => {
    function update() {
      const zoom = map.getZoom();
      if (zoom === lastZoom.current) return;
      lastZoom.current = zoom;
      layerRef.current?.setOpacity(opacityForZoom(zoom));
    }

    update();
    map.on('zoomend', update);
    return () => { map.off('zoomend', update); };
  }, [map, layerRef]);
}
